import { PropTypes } from 'prop-types';
import { useEffect } from 'react';
import UtilityTable from './UtilityTable';
import { selectSite } from '../../../store/authReducer';
import { useSelector } from 'react-redux';

export const UtilityDataGetter = (props) => {
  const primarySiteId = useSelector(selectSite);
  useEffect(() => {
    props.fetchUtilities({
      currentFilters: {
        utilityType: props.pageFilter,
      },
    });
    props.fetchUtilityUnits();
  }, [props.userGroup.permissions, primarySiteId]);
  useEffect(() => {
    props.fetchUtilities({
      currentFilters: {
        utilityType: props.pageFilter,
      },
    });
  }, []);

  return <UtilityTable {...props} />;
};
/* eslint-di sable */
UtilityDataGetter.propTypes = {
  fetchUtilities: PropTypes.func.isRequired,
  fetchUtilityUnits: PropTypes.func.isRequired,
  getUtility: PropTypes.func.isRequired,
  saveUtility: PropTypes.func.isRequired,
  deleteUtility: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      site: PropTypes.string,
    }),
  }),
};

export default UtilityDataGetter;
